var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.58543C0 7.16738 1.14956 6.01782 2.56761 6.01782H11.1263C12.5444 6.01782 13.6939 7.16738 13.6939 8.58543V15.4324C13.6939 16.8505 12.5444 18 11.1263 18H2.56761C1.14956 18 0 16.8505 0 15.4324V8.58543ZM2.56761 7.72956C2.09493 7.72956 1.71174 8.11273 1.71174 8.58543V15.4324C1.71174 15.9051 2.09493 16.2883 2.56761 16.2883H11.1263C11.599 16.2883 11.9822 15.9051 11.9822 15.4324V8.58543C11.9822 8.11273 11.599 7.72956 11.1263 7.72956H2.56761Z",
    fill: "#49712B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41446 6.84695C9.88716 6.84695 10.2703 6.46376 10.2703 5.99108V4.27935C10.2703 2.8613 11.4198 1.71174 12.8379 1.71174C14.256 1.71174 15.4055 2.8613 15.4055 4.27935V5.99108C15.4055 6.46376 15.7887 6.84695 16.2614 6.84695C16.7341 6.84695 17.1173 6.46376 17.1173 5.99108V4.27935C17.1173 1.91593 15.2013 0 12.8379 0C10.4745 0 8.55859 1.91593 8.55859 4.27935V5.99108C8.55859 6.46376 8.94177 6.84695 9.41446 6.84695Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55824 11.1531C8.55824 12.0985 7.7919 12.8649 6.8465 12.8649C5.90114 12.8649 5.13477 12.0985 5.13477 11.1531C5.13477 10.2078 5.90114 9.44141 6.8465 9.44141C7.7919 9.44141 8.55824 10.2078 8.55824 11.1531Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.84708 11.1531C7.31978 11.1531 7.70295 11.5362 7.70295 12.0089V13.7207C7.70295 14.1934 7.31978 14.5766 6.84708 14.5766C6.3744 14.5766 5.99121 14.1934 5.99121 13.7207V12.0089C5.99121 11.5362 6.3744 11.1531 6.84708 11.1531Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/lock-open.a12432cbe405def78cce051eb24fa6e7.svg";
export { ForwardRef as ReactComponent };